import http from "./http-common";
import ResearchApi from "./ResearchApi";
import {useDispatch} from "react-redux";

// Login service
// Calls backend API for login actions
export const LoginService = (myContext = null) => {
    const dispatch = useDispatch();
    const Token = (Email , Role , user) => {
        user.provider = user.provider ? user.provider : user._provider;
        user.token = user.token ? user.token : user._token;
        return http.post(`/auth`, {
            "Credential" : user.provider === "google" ?  user.token.idToken : user.token.accessToken ,
            "loginType":user.provider === "google" ?  2 : 3,
            "role": Role,
            "email": Email 
        });
    }

    // LoginType
    // 1 => Local
    // 2 => Google
    // 3 => facebook

    const tokenRefresh = (Email, role, lg) => {

        return http.post(`/auth`, {
            "loginType": 1,
            "role": role === 'Admin' ? 2 : (role === 'Client' ? 1 : 0),
            "email": Email,
            "languages": lg === 'en' ? 0 : 1
        }).finally(() => ResearchApi(dispatch));
    }


    const ValidToken = (Email , Role) =>  {    
        return http.get(`/me/${Email}/${Role}`);
    }

    const PreRegister = (DataUser) => {
        return http.post(`/pre-register`, DataUser);
    }

    const PreRegisterExternal = (DataUser) => {
        return http.post(`/register/external`, DataUser);
    }

    const Register = (IdUser ,Role , CodeOtp) => {
        return http.post(`/register/validactive/${IdUser}/${Role}/${CodeOtp}`, {});
    }

    const DeleteAccount = (IdUser , Role ) => {
        return http.delete(`/delete/${IdUser}/${Role}`);
    }

    // TOKEN

    const getLocalRefreshToken = () => {
        const user = JSON.parse(localStorage.getItem("tokenMKT"));
        return user?.refreshToken;
    }

    const getLocalAccessToken = () => {
        return localStorage.getItem("tokenMKT");
    }

    const updateLocalAccessToken = (token) => {
        const user = JSON.parse(localStorage.getItem("tokenMKT"));
        user.accessToken = token;
        localStorage.setItem("tokenMKT", JSON.stringify(user));
    }

        const getUser = () => {
        return JSON.parse(localStorage.getItem("tokenMKT"));
    }

    const setUser = (user) => {
        console.log(JSON.stringify(user));
        localStorage.setItem("tokenMKT", JSON.stringify(user));
    }

    const removeUser = () => {
        localStorage.removeItem("tokenMKT");
    }
  
    return {
        Token,
        PreRegister,
        Register,
        PreRegisterExternal,
        ValidToken,
        DeleteAccount,
        tokenRefresh,
        getLocalRefreshToken,
        getLocalAccessToken,
        updateLocalAccessToken,
        getUser,
        setUser,
        removeUser
    };
};
